import { render, staticRenderFns } from "./SoftOneApiForm.vue?vue&type=template&id=342a47ba"
import script from "./SoftOneApiForm.vue?vue&type=script&lang=js"
export * from "./SoftOneApiForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports